import { memo } from "react";
import { GanttSection } from "./components/GanttSection/GanttSection";

// Export a memoized version of the component
export const MemoizedGanttSection = memo(GanttSection);
